<div *ngIf="activityContext" class="activity-wrapper" [ngClass]="this.activityContext?.activityState">
  <div class="timeline-icon" [class]="activityContext.iconStateClass">
    <span [class]="activityContext.iconClass"></span>
  </div>

  <ng-container [ngSwitch]="activityTypeId">
    <ng-container *ngSwitchCase="-1"> <!-- description --> </ng-container>

    <xs-note-activity
      *ngSwitchCase="1"
      [activity]="activity"
      [activityCtrl]="activityContext"
      (updatePrivacyIcon)="updatePrivacyIcon($event)"
      (isEditting)="isEditting.emit($event)"
      (refresh)="onRefresh.emit($event)"
    ></xs-note-activity>

    <xs-attachment-activity
      *ngSwitchCase="2"
      [activity]="activity"
      [canEdit]="canEditAttachments"
      [activityCtrl]="activityContext"
      [isSPPMode]="isSPPMode"
      (isEditting)="isEditting.emit($event)"
      (addedAttachment)="ticketPageService.refresh()"
    ></xs-attachment-activity>

    <xs-inbound-email-activity
      *ngSwitchCase="3"
      [activity]="activity"
      [activityCtrl]="activityContext"
    ></xs-inbound-email-activity>

    <xs-outbound-email-activity
      *ngSwitchCase="4"
      [activity]="activity"
      [activityCtrl]="activityContext"
    ></xs-outbound-email-activity>

    <xs-remote-control-activity
      *ngSwitchCase="5"
      [activity]="activity"
      [activityCtrl]="activityContext"
    ></xs-remote-control-activity>

    <xs-device-capture-activity
      *ngSwitchCase="[6, 8, 9].includes(activityTypeId) ? activityTypeId : null"
      [activity]="activity"
      [canEdit]="canEditAttachments"
      [activityCtrl]="activityContext"
      [isSPPMode]="isSPPMode"
      (isEditting)="isEditting.emit($event)"
    ></xs-device-capture-activity>

    <xs-snapshot-activity
      *ngSwitchCase="7"
      [snapshot]="activity"
      [isSPPMode]="isSPPMode"
      (isEditting)="isEditting.emit($event)"
      [activityCtrl]="activityContext"
    ></xs-snapshot-activity>

    <div *ngSwitchCase="101"></div>

    <div *ngSwitchDefault (click)="detail = !detail">
      <div class="ticket-description-label">Something went wrong with {{ activityTypeId }}</div>
      <pre *ngIf="detail">{{ activity | json }}</pre>
    </div>
  </ng-container>

  <ng-content></ng-content>

  <div *ngIf="!isFooter" class="activity-timeline"></div>
</div>
